// extracted by mini-css-extract-plugin
export default {"grid":"_HWqnJ","lg":"QI8zb7","xl":"IW5Xec"};